import { useFormApi } from '@data-driven-forms/react-form-renderer';

import SimpleGrid from '~/common/components/Grids/Grid/SimpleGrid';

type GridProps = {
  fields?: any[];
  name?: string;
  columns?: number;
  rowSpacing?: string;
  columnSpacing?: string;
  sx?: any;
};

export default function Grid({
  fields = [],
  name,
  columns,
  rowSpacing = '10px',
  columnSpacing = '10px',
  sx,
}: Readonly<GridProps>) {
  const { renderForm } = useFormApi();

  const styles = {
    marginBottom: '1rem',
    ...sx,
  };

  return (
    <SimpleGrid
      id={name}
      columnGap={columnSpacing}
      rowGap={rowSpacing}
      gridTemplateColumns={`repeat(${columns}, 1fr)`}
      sx={styles}
    >
      {renderForm(fields)}
    </SimpleGrid>
  );
}
